// extracted by mini-css-extract-plugin
export default {"tableWrapper":"RolesPage_tableWrapper__80g7k","oddRow":"RolesPage_oddRow__k4XTp"};